import { useEffect } from 'react';
import { useAudio } from '../hooks/useAudio';
import './AudioController.css';

interface AudioControllerProps {
  currentPowerMW: number;
  peakPowerMW: number;
  mapZoom: number;
}

export function AudioController({ currentPowerMW, peakPowerMW, mapZoom }: AudioControllerProps) {
  const { isMuted, volume, toggleMute, setVolume, updateGeneration, updateZoom } = useAudio();

  // Update audio based on generation
  useEffect(() => {
    updateGeneration(currentPowerMW, peakPowerMW);
  }, [currentPowerMW, peakPowerMW, updateGeneration]);

  // Update audio based on zoom
  useEffect(() => {
    updateZoom(mapZoom);
  }, [mapZoom, updateZoom]);

  return (
    <div className="audio-controller">
      <button 
        className={`audio-mute-btn ${isMuted ? 'muted' : ''}`}
        onClick={toggleMute}
        aria-label={isMuted ? 'Unmute audio' : 'Mute audio'}
        title={isMuted ? 'Unmute inverter hum' : 'Mute inverter hum'}
      >
        {isMuted ? (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 5L6 9H2v6h4l5 4V5z" />
            <line x1="23" y1="9" x2="17" y2="15" />
            <line x1="17" y1="9" x2="23" y2="15" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 5L6 9H2v6h4l5 4V5z" />
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
          </svg>
        )}
      </button>
      
      {!isMuted && (
        <div className="audio-volume">
          <input
            type="range"
            min="0"
            max="0.15"
            step="0.01"
            value={volume}
            onChange={(e) => setVolume(parseFloat(e.target.value))}
            className="volume-slider"
            aria-label="Volume"
          />
        </div>
      )}
      
      <span className="audio-label">
        {isMuted ? 'Sound off' : 'Inverter hum'}
      </span>
    </div>
  );
}

